import { ComponentType } from "react";
import { twMerge } from "tailwind-merge";

type IconComponent = ComponentType<{ size?: number; color?: string }>;

interface IconBoxPreset {
  bg: string;
  iconSize: number;
  iconColor: string;
}

const presets = {
  danger: { bg: "#FFF5F2", iconSize: 20, iconColor: "#E02800" },
  warning: { bg: "#FFF7ED", iconSize: 20, iconColor: "#F59E0B" },
  disabled: { bg: "#F2F4F7", iconSize: 20, iconColor: "#98A2B3" },
} satisfies Record<string, IconBoxPreset>;

interface IconBoxProps {
  icon: IconComponent;
  preset?: keyof typeof presets;
  bg?: string;
  iconSize?: number;
  iconColor?: string;
  className?: string;
}

export function IconBox({
  icon: Icon,
  preset,
  bg,
  iconSize,
  iconColor,
  className,
}: IconBoxProps) {
  const p = preset ? presets[preset] : undefined;
  const resolvedBg = bg ?? p?.bg;
  const resolvedSize = iconSize ?? p?.iconSize;
  const resolvedColor = iconColor ?? p?.iconColor;

  return (
    <div
      className={twMerge("inline-flex items-center justify-center", className)}
      style={{ background: resolvedBg, padding: 12, borderRadius: 12 }}
    >
      <Icon size={resolvedSize} color={resolvedColor} />
    </div>
  );
}
